<template>
  <div class="mypageContents">
    <div class="mypageContents_main">
      <slot />
    </div>
    <div class="mypageContents_sideNav">
      <TileButtons :items="buttonItems" class="-sideNav" />
      <section class="section">
        <HeadingLv3 text="基本情報" />
        <SimpleLinkList :items="kihon" class="-sideNav" />
      </section>
      <section class="section">
        <HeadingLv3 text="その他" />
        <SimpleLinkList :items="others" />
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import TileButtons from '@/components/block/TileButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import SimpleLinkList from '@/components/block/SimpleLinkList.vue'

export default defineComponent({
  name: 'MypageContents',

  components: {
    TileButtons,
    SimpleLinkList,
    HeadingLv3
  },

  setup() {
    const store = useStore()
    const userInfo = store.state.userInfo

    const buttonItems = [
      {
        icon: 'heart',
        label: 'お気に入り病院一覧',
        link: '/mypage/bookmark/list',
        badgeNum:
          userInfo.favorite_history.length + userInfo.s_favorite_history.length
      },
      {
        icon: 'document',
        label: '資料請求一覧',
        link: '/mypage/document_request/list',
        badgeNum:
          userInfo.request_history.length + userInfo.s_request_history.length
      },
      {
        icon: 'hospital-02',
        label: '病院見学一覧',
        link: '/mypage/visit_application/list',
        badgeNum:
          userInfo.inspection_history.length +
          userInfo.s_inspection_history.length
      },
      {
        icon: 'calendar',
        label: '申込イベント一覧',
        link: '/mypage/event/list',
        badgeNum: userInfo.event_history ? userInfo.event_history.length : 0
      }
    ]

    const kihon = [
      {
        heading: '登録情報の確認・変更',
        link: '/mypage/user/profile',
        label: userInfo.required_flg ? '' : '未設定項目あり'
      },
      {
        heading: '保存した検索条件',
        link: '/mypage/saved_search_conditions/list',
        label: ''
      }
      // {
      //   heading: 'パスワード変更',
      //   link: '',
      //   label: ''
      // }
      // {
      //   heading: '登録情報',
      //   link: '',
      //   label: ''
      // }
    ]

    const others = [
      {
        heading: 'お問い合わせ',
        link: '/contact/input',
        label: ''
      },
      {
        heading: 'ログアウト',
        link: '/logout',
        label: ''
      }
      // {
      //   heading: '退会',
      //   link: '',
      //   label: ''
      // }
    ]
    return {
      buttonItems,
      kihon,
      others
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';

.mypageContents {
  @include mixins.media() {
    display: flex;
    align-items: flex-start;
  }
  &_main {
    @include mixins.media() {
      flex-basis: 74%;
      max-width: 74%;
    }
  }
  &_sideNav {
    display: none;
    @include mixins.media() {
      display: block;
      flex: 1;
      margin-left: 40px;
      ::v-deep(.headingLv3) {
        margin-bottom: 0;
      }
      .section {
        margin-top: 50px;
      }
    }
  }
}
</style>
